import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { UserInfoService } from "../../services/user-info.service";
import { getHomeRedirectForRole } from "./platform-role-policy";

/**
 * Keeps authenticated users inside their platform area.
 * - PAID_CUSTOMER -> /paid
 * - ACTIVE / EXTERNAL -> /
 */
export const authenticatedPlatformRedirectGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const userInfoService = inject(UserInfoService);
  const role = userInfoService.getSessionContext()?.patientRole;
  const redirectTo = getHomeRedirectForRole(role);

  if (!redirectTo) {
    return true;
  }
  router.navigate([redirectTo]);
  return false;
};

